import "core-js/modules/es.array.find";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

var ProxyListTable = /*#__PURE__*/function (_Vue) {
  _inherits(ProxyListTable, _Vue);

  var _super = _createSuper(ProxyListTable);

  function ProxyListTable() {
    var _this;

    _classCallCheck(this, ProxyListTable);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic;
    return _this;
  }

  _createClass(ProxyListTable, [{
    key: "handleEdit",
    value: function handleEdit(item) {
      return item;
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      return item;
    }
  }, {
    key: "onComfireDelete",
    value: function onComfireDelete(item) {
      var _this2 = this;

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u5220\u9664".concat(item.row.procuratorName, ", \u662F\u5426\u7EE7\u7EED?"), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function () {
        _this2.handleDelete(item);
      }).catch(function () {});
    }
  }, {
    key: "getIdCardType",
    value: function getIdCardType(certificateType) {
      var idCardType = this.dic.certificateTypeList.find(function (i) {
        return certificateType && i.value === certificateType;
      });
      return "".concat(idCardType ? idCardType.label : '');
    }
  }]);

  return ProxyListTable;
}(Vue);

__decorate([Prop({
  required: true
})], ProxyListTable.prototype, "data", void 0);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], ProxyListTable.prototype, "editable", void 0);

__decorate([Emit('onEdit')], ProxyListTable.prototype, "handleEdit", null);

__decorate([Emit('onDelete')], ProxyListTable.prototype, "handleDelete", null);

ProxyListTable = __decorate([Component({
  components: {}
})], ProxyListTable);
export default ProxyListTable;